export const VARIANT = {
  inline: 'inline',
  singleline: 'singleline',
  multiline: 'multiline',
} as const;

export const SIZE = {
  tiny: 'tiny',
  small: 'small',
  medium: 'medium',
} as const;

export const COPY_BUTTON_SIZE = {
  small: 'small',
  medium: 'medium',
} as const;

export const DEFAULT_TOOLTIP_IDLE = 'Copy to clipboard';
export const DEFAULT_TOOLTIP_COPIED = 'Copied to clipboard';

export const COPY_RESET_TIMEOUT_MS = 3000;

export const DATA_HOOKS = {
  copyButton: 'codesnippet-copy',
  code: 'codesnippet-code',
} as const;
